/* globals Option */

window['attachment_relations/sends#new'] = () => {
  const select = $('#selected_attachment_ids')

  document.addEventListener('click', function (event) {
    if (!event.target.matches('.check_attachment')) return

    const target = event.target
    const id = target.value

    if (target.checked) {
      const filename = target.closest('div.dz-preview').querySelector('.dz-filename').innerHTML
      select.append(new Option(filename, id))
      const selected = select.val()
      selected.push(id)
      select.val(selected).change()
    } else {
      $(`#selected_attachment_ids option[value="${id}"`).remove()
      select.change()
    }
  })

  document.addEventListener('attachments_listed', () => {
    const selectedIds = select.val()
    const checkBoxes = document.querySelectorAll('.check_attachment')
    checkBoxes.forEach((item) => {
      if (selectedIds.includes(item.value)) {
        item.checked = true
      }
    })
  })
}
